import React, { useRef, useLayoutEffect, useState } from 'react';
import Event from './Event';
import Holiday from './Holiday';

const dayClickHandler = (date, clickable, monthName, history, isAdmin) => {
  if (clickable) {
    history.push(`/calendar/${isAdmin ? "admin/": ""}${monthName}/${date}`);
  } else {
    return
  }
}

const handleHover = (overflowCheck, dateId) => {
  if (overflowCheck) {
    document.getElementById(dateId).classList.toggle("dayWrapOverflowFade");
  }
}

const isToday = (date, monthData) => {
  if (!date || !monthData) return false;
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();
  const currentDate = today.getDate();
  
  return (
    monthData.year === currentYear &&
    monthData.monthNo === currentMonth &&
    date === currentDate
  );
};

const Day = ({ dayData, monthName, history, match, monthData }) => {
  let { date, holiday, message, events } = dayData;
  const isAdmin = match.path === "/calendar/admin";
  const clickable = date !== null && (events.length > 0 || holiday || isAdmin);
  const [overflowCheck, setOverflowCheck] = useState(false);
  const dateId = `day${date}`;
  const dayElem = useRef(null);
  const todayClass = isToday(date, monthData) ? "data-today" : "";


  useLayoutEffect(() => {
    if (dayElem.current && dayElem.current.clientHeight < dayElem.current.scrollHeight) {
      setOverflowCheck(true);
    }
  },[overflowCheck, monthName, date]);

  return (
    <>
      <div 
        className={`dayWrapFormat dayWrap ${clickable ? "dayWrapCursor": ""}`}
        data-today={isToday(date, monthData)}
        ref={dayElem}
        onClick={() => dayClickHandler(
          date, 
          clickable,
          monthName, 
          history,
          isAdmin)}
        onMouseEnter={() => handleHover(overflowCheck, dateId) }
        onMouseLeave={() => handleHover(overflowCheck, dateId) }
        role={clickable ? "button" : "cell"}
        tabIndex={clickable ? 0 : -1}
        aria-label={`${monthName} ${date}${events.length > 0 ? `, ${events.length} event${events.length > 1 ? 's' : ''}` : ''}${holiday ? ', holiday' : ''}`}>
        
        {date && <p className="calendarHeaderText">{date}</p>}
        
        <div className="day-content">
          <Holiday holiday={holiday} message={message} />
          {
            events.map((event, index) => (
              <Event 
                key={`day${date}Event${index + 1}`} 
                event={event} 
              />
            ))
          }
        </div>
        
        {
          overflowCheck ?
          <p id={dateId} className="dayWrapOverflow">{`Click to see more`}</p>
          :
          null
        }
      </div>
    </>
  )  
}

export default Day;